<template>
    <div>
        <!-- 围栏校验提示框 -->
        <el-dialog
            title="提示"
            :visible="true"
            width="30%"
            append-to-body
            :before-close="handleClose"
            :custom-class="'tooltipDialog'">
            <span class="tooltip">{{ tooltipContent }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">否</el-button>
                <el-button type="primary" @click="confirm">是</el-button>
            </span>
        </el-dialog>

        <!-- 人工操作原因弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            append-to-body
            :before-close="handleClose">
            <el-input type="textarea" v-model="operateReason" placeholder="请填写人工操作原因" clearable maxlength="50" show-word-limit :rows="3"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { saveOperateReason } from '../../../../api/dispatchOrder.js';
export default {
    name: 'DispatchHandleReason',
    props: {
        handleType: {
            type: String,
            default: ''
        },
        dispatchNo: {
            type: String,
            default: ''
        },
        componentsData: {
            type: [String, Object, Array]
        }
    },
    data () {
        return {
            btnLoading: false,
            dialogVisible: false, // 是否显示人工操作原因弹窗
            operateReason: '', // 人工操作原因
            type: {
                'arrive': '1', // 到车
                'depart': '2', // 发车
                'arrival': '3' // 抵达
            }
        };
    },
    computed: {
        tooltipContent () {
            return this.handleType === 'depart' ? '当前车辆没有离开装货电子围栏，是否确认操作?' : '当前车辆不在站点电子围栏范围内，是否确认操作?';
        }
    },
    methods: {
        // 取消操作
        handleClose () {
            this.dialogVisible = false;
            this.$emit('closeFenceDialog');
        },
        // 确认操作
        confirm () {
            this.dialogVisible = true;
        },
        // 组装参数
        getParams () {
            const dispatchNo = Array.isArray(this.componentsData) ? this.componentsData.map(v => v.etdoNo) : [this.componentsData.etdoNo];
            const params = {
                dispatchNo: dispatchNo,
                type: this.type[this.handleType],
                msg: this.operateReason
            };
            return params;
        },
        // 提交
        handleSubmit () {
            if (this.operateReason.trim() === '') {
                return this.$message.warning('人工操作原因不能为空');
            }
            const params = this.getParams();
            this.btnLoading = true;
            saveOperateReason(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data.data);
                    this.btnLoading = false;
                    this.handleClose();
                    this.callback();
                } else {
                    this.handleClose();
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        // 触发回调函数
        callback () {
            if (this.handleType === 'depart') {
                this.$emit('handleSuccess', { isFenceRemarked: true });
            } else {
                this.$emit('handleSuccess', { isFenceRemarked: true, data: this.componentsData });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.tooltipDialog {
    .el-dialog__body {
        .tooltip{
            font-size: 14px;
        }
    }
}
</style>
